import actions from '@/core/store/ocorrencia/actions'
import getters from '@/core/store/ocorrencia/getters'
import mutations from '@/core/store/ocorrencia/mutations'
import state from '@/core/store/ocorrencia/state'

export default {
	actions,
	getters,
	mutations,
	state,
}
